import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})

export class TourService {

  constructor(
    private logger: LoggerService
    , private http: HttpClient,
    private router: Router
  ) {
    this.positionStyle = ``;
    this.popoverPositionStyle = ``;
    this.tourItems = [];
    this.tourList = [];
    this.thisTourIndex = 0;
    this.hasStartedTour = false;
  }

  public tourList: any[];

  public tourItems: any[];

  public thisTourIndex: number;

  public isShow: boolean = false;

  public positionStyle: string;

  public popoverPositionStyle: string;

  public hasStartedTour: boolean;

  public setTour(routing: string): void {
    this.http.get<[]>
      (`./assets/tour-json/tour.json`)
      .subscribe((tourItemsList) => {
        this.tourList = tourItemsList;
        this.tourItems = this.tourList
          .filter(current => current.routing == routing)[0].items;
      });
  }

  public startTour(): void {
    if (!this.hasStartedTour) {
      if (this.tourItems.length <= 0) {
        this.logger.addWarning("tour file dont assigned...!!",false);
        return
      }
      this.thisTourIndex = 0;
      this.isShow = true;

      //document.getElementsByClassName('layout-page')[0].classList.add("tour-disable");
      //document.getElementsByClassName('layout-menu')[0].classList.add("tour-disable");

      this.next();

      var foundedItembtn = document.getElementById("tour-background-btn");
      if (foundedItembtn) {
        foundedItembtn.click();
      }
      this.hasStartedTour = true;
    }
  }

  public next(): void {

    if (this.tourItems.length <= 0) {
      this.logger.addWarning("tour file dont assigned...!!",false);
      return
    }

    if (this.tourItems.length <= this.thisTourIndex) {
      this.logger.addWarning("tour is finish...!!",false);
      return
    }

    const thisTourItem = this.tourItems[this.thisTourIndex];

    if (thisTourItem.routing != null) {
      this.router.navigate([thisTourItem.routing]);
    }

    var foundedItem = this.selectItem(thisTourItem.selector)
    if (foundedItem) {
      var element = foundedItem.getBoundingClientRect();

      this.positionStyle = `top:${element.y}px;left:${element.x}px;height:${element.height}px;width:${element.width}px;`;

      this.popoverPositionStyle = `top:${element.top + element.height}px;bottom:${element.bottom + element.height}px;left:${element.left}px;right:${element.right}px;height:${element.height}px;width:${element.width}px;`;
    }
  }

  public endTour(): void {
    this.isShow = false;
    this.hasStartedTour = false;
  }

  private selectItem(elementSelector: string): any {
    try {
      if (elementSelector.indexOf('#') >= 0) {
        return document.getElementById(elementSelector.replace('#', ''));
      }

      if (elementSelector.indexOf('.') >= 0) {
        return document.getElementsByClassName(elementSelector.replace('.', ''))[0];
      }

    } catch (error) {
      return null;
    }
  }

}
